import { getTravleDetailRecommend } from '@/axios/api'

const travleDetailRecommend = {
  state: {
    travleDetailRecommend: {}
  },
  mutations: {
    SET_TRAVLEDETAILRECOMMEND (state, travleDetailRecommend) {
      state.travleDetailRecommend = travleDetailRecommend
    }
  },
  actions: {
    TRAVLEDETAILRECOMMEND ({ commit }, params) {
      getTravleDetailRecommend(params).then(res => {
        this.state.travleDetailRecommend = res.data.data
      })
    }
  }
}

export default travleDetailRecommend



// WEBPACK FOOTER //
// ./src/store/modules/getTravleDetailRecommend.js